import { render, staticRenderFns } from "./YwArtificialPatrolTaskDetailList.vue?vue&type=template&id=bdbe1108&scoped=true&"
import script from "./YwArtificialPatrolTaskDetailList.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolTaskDetailList.vue?vue&type=script&lang=js&"
import style0 from "./YwArtificialPatrolTaskDetailList.vue?vue&type=style&index=0&id=bdbe1108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbe1108",
  null
  
)

export default component.exports